import FlooringFiltersForm from "./flooring-filters-form";

export default FlooringFiltersForm;